import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Image } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import css from './Hero.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Hero = function Hero(_ref) {
  var copy = _ref.copy,
      cta = _ref.cta,
      url = _ref.url,
      image = _ref.image,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("p", {
        className: css.copy,
        children: copy
      }), /*#__PURE__*/_jsx("div", {
        className: css.button,
        children: /*#__PURE__*/_jsx(Button, {
          big: true,
          white: true,
          href: url,
          children: /*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: {
              __html: cta
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: css.image,
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        wrap: false,
        lazyload: false,
        sizes: [320, 480, 600, 800, 1000, 1200, 1420]
      }))
    })]
  });
};

Hero.propTypes = {
  copy: PropTypes.string,
  cta: PropTypes.string,
  image: PropTypes.shape({}),
  title: PropTypes.string,
  url: PropTypes.string
};
export default Hero;